import { TeeTimeSlot, TeeTimeSlotDisplay, ClubCourseData, TeeTimeBookingPlayer } from '../../../../data/mygolf.data';
import {
    Component,
    HostListener,
    Input
} from "@angular/core";
import { NavParams, ToastController, Platform, ModalController } from "@ionic/angular";
import { CourseInfo, CourseHoleInfo } from "../../../../data/club-course";
import { ClubFlightService } from "../../../../providers/club-flight-service/club-flight-service";
import { TeeTimeBooking, TeeTimePriceComponent, TeeTimePrice } from "../../../../data/mygolf.data";


import * as moment from "moment";
import { MessageDisplayUtil } from '../../../../message-display-utils';
import { Router } from '@angular/router';
/**
 * Created by ashok on 19/12/16.
 */
@Component({
    templateUrl: 'additional-items-list.html',
    selector: 'additional-items-list-page',
    styleUrls: ['additional-items-list.scss'],
})
export class AdditionalItemsListModal {
    @Input("value") courses: any;
    @Input() isModal: boolean = false;
    // @Input() courses: Array<CourseInfo>;
    clubId: number;
    forDate: string;
    isClub: boolean = false;
    courseId: number;
    teeSlot: Array<TeeTimeSlotDisplay>;
    startCourses: Array<ClubCourseData>;
    changeType: string;
    currentSlot: TeeTimeBooking;
    color: string;
    currentTime: string;
    currentDate: string;

    itemReq: number = 0;

    appFooterHide: boolean = true;

    itemsReq: Array<number> = [];

    additionalItems: Array<any> = [];
    pricingComponents: Array<TeeTimePriceComponent> = [];
    slotPrices: Array<TeeTimePrice> = [];
    bookingPlayer: TeeTimeBookingPlayer;

    mode: string = 'add';
    existingAddItems: Array<any> = [];
    initialItemValuesArray:any[] = [];
    fromClub: boolean = false;
    currencySymbol: string;
    constructor(
        private flightService: ClubFlightService,
        private navParams: NavParams,
        private toastCtl: ToastController,
        private router: Router,
        private platform: Platform,
        private modalCtl: ModalController) {
        // this.courses = navParams.get("courses");
        this.clubId = navParams.get("clubId");
        this.forDate = navParams.get("forDate");
        this.courseId = navParams.get("courseId");
        this.changeType = navParams.get("changeType");
        this.currentSlot = navParams.get("currentSlot");
        this.pricingComponents = navParams.get("pricingComponents");
        this.slotPrices = navParams.get("slotPrices");

        this.bookingPlayer = navParams.get("bookingPlayer");
        this.mode = navParams.get("mode");
        this.existingAddItems = navParams.get("existingAddItems");
        this.fromClub = navParams.get("fromClub");
        if (this.changeType && this.changeType === 'slot') this.isClub = false;
        else if (this.changeType && this.changeType === 'course') this.isClub = true;
        else if (this.changeType && this.changeType === 'slotDate') {
            this.isClub = true;
            this.currentDate = this.forDate;
        }

        let _ninesPlayed = this.currentSlot.ninesPlayed;

        if (this.currentSlot && this.currentSlot.clubData) {
            if (this.currentSlot.clubData.address.countryData) {
                this.currencySymbol = this.currentSlot.clubData.address.countryData.currencySymbol;
            }
        }
        if (this.mode === 'add') {
            this.slotPrices.forEach((price: TeeTimePrice) => {
                this.additionalItems.push({
                    itemName: price.priceComponent.name,
                    unitPriceUsed: _ninesPlayed === 1 ? price.price9Hole : price.price18Hole,
                    componentId: price.priceComponent.id,
                    bookingPlayerId: this.bookingPlayer ? this.bookingPlayer.id : null,
                    itemCount: 0,
                    remarkShow: false,
                    remarks: '',
                    playerType: price.playerType ? price.playerType.name : null
                })
            })
        } else if (this.mode === 'edit') {
            const itemArray = this.existingAddItems;
            console.log('itemArray: ', itemArray);
            this.additionalItems = JSON.parse(JSON.stringify(itemArray));
            console.log('this.additionalItems: ', this.additionalItems);

            this.additionalItems.forEach((item: any) => {
                item.itemName = item.component.name;
                item.unitPriceUsed = item.unitPriceUsed;
                item.componentId = item.component.id;
                item.bookingPlayerId = this.bookingPlayer ? this.bookingPlayer.id : null;
                item.playerType = item.playerType ? item.playerType.name : item.bookingPlayer ? item.bookingPlayer.playerType.name : null;
            });

            let _newPrices = this.slotPrices.filter((price: TeeTimePrice) => {
                let _canAdd: boolean = false;
                let _componentId = 0;
                this.additionalItems.filter((item) => {
                    if (item.componentId === price.priceComponent.id)
                        return true
                    else if (item.component && item.component.id === price.priceComponent.id)
                        return true
                    // else if(item.itemCount > 0) return false
                    else return false
                }).map((item) => {
                    _canAdd = true
                });
                return !_canAdd;

            });
            if (_newPrices && _newPrices.length > 0) {
                _newPrices.forEach((price) => {
                    this.additionalItems.push({
                        itemName: price.priceComponent.name,
                        unitPriceUsed: _ninesPlayed === 1 ? price.price9Hole : price.price18Hole,
                        componentId: price.priceComponent.id,
                        bookingPlayerId: this.bookingPlayer ? this.bookingPlayer.id : null,
                        itemCount: 0,
                        remarkShow: false,
                        remarks: '',
                        playerType: price.playerType ? price.playerType.name : null
                    })
                })
            }


            // .map((price)=>{
            //     //
            //     // this.additionalItems.push({
            //     //     itemName: price.priceComponent.name,
            //     //     unitPriceUsed: _ninesPlayed===1?price.price9Hole:price.price18Hole,
            //     //     componentId: price.priceComponent.id,
            //     //     bookingPlayerId: this.bookingPlayer?this.bookingPlayer.id:null,
            //     //     itemCount: 0,
            //     //     remarkShow: false,
            //     //     remarks: '',
            //     //     playerType: price.playerType?price.playerType.name:null
            //     // })
            // })
            //
            //
            //
        }
        //
        // this.additionalItems = [{
        //     itemName: 'Additional Buggy',
        //     itemPrice: 50,
        //     itemQty: 0,
        //     remarkShow: false,
        //     remarks: '',
        // },{
        //     itemName: 'Additional Caddy',
        //     itemPrice: 50,
        //     itemQty: 0,
        //     remarkShow: false,
        //     remarks: '',
        // },{
        //     itemName: 'Insurance',
        //     itemPrice: 5.30,
        //     itemQty: 0,
        //     remarkShow: false,
        //     remarks: '',
        // },{
        //     itemName: 'Online Discount',
        //     itemPrice: 5.30,
        //     itemQty: 0,
        //     remarkShow: false,
        //     remarks: '',
        // }]

    }


    innerWidth: any;
    ngOnInit() {
        this.initialItemValuesArray = JSON.parse(JSON.stringify(this.additionalItems));
        this.innerWidth = window.innerWidth;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.innerWidth = window.innerWidth;
    }

    ionViewDidLoad() {
        // this.getTeeTimeBookingList();
    }
    close() {
        this.modalCtl.dismiss();
    }
    onAddItems() {
        let _params;
        let _bookingId = this.currentSlot.id;

        console.log('this.additionalItems: ', this.additionalItems);
        this.additionalItems.forEach((item) => {
            item['unitPrice'] = item['unitPriceUsed'];
        })
        if (this.mode === 'edit') {
            this.onRemoveItems()
                .then((result) => {
                    if (result) {
                        _params = this.additionalItems.filter((item) => {
                            return item.itemCount > 0
                        });
                        this.flightService.addUpdateAdditionalItems(_bookingId, _params)
                            .subscribe((data) => {
                                if (data) {
                                    console.log('this.isModal: ', this.isModal);
                                    if(this.isModal){
                                        console.log("IFFFFFF");

                                        this.modalCtl.dismiss(true);
                                      }else{
                                        console.log("ELSEEEEEEE");

                                        this.router.navigate(['booking-details']);
                                      }
                                }
                            })
                    }
                });
        } else {
            // _params = this.additionalItems;
            _params = this.additionalItems.filter((item) => {
                return item.itemCount > 0
            });
            this.flightService.addUpdateAdditionalItems(_bookingId, _params)
                .subscribe((data) => {
                    if (data) {
                        if(this.isModal){
                            this.modalCtl.dismiss(true);
                          }else{
                            this.router.navigate(['booking-details']);
                          }
                    }
                })
        }

    }
    onRemoveItems() {
        return new Promise((resolve, reject) => {
            if (!this.currentSlot) reject()
            let _itemsToRemove = [];
            this.additionalItems.filter((item) => {
                if (item.itemCount === 0)
                    return true
            }).map((item) => {
                _itemsToRemove.push(item.id)
            }); // .pop();
            this.additionalItems = this.additionalItems.filter((item) => {
                return item.itemCount > 0
            })

            let _bookingId = this.currentSlot.id;
            if (_itemsToRemove && _itemsToRemove.length > 0) {
                this.flightService.deleteAdditionalItems(_bookingId, _itemsToRemove)
                    .subscribe((data) => {

                        resolve(true)
                    })
            } else resolve(true)
        })
    }
    selectHole(hole: CourseHoleInfo, whichNine: number) {
        this.modalCtl.dismiss({
            hole: hole,
            whichNine: whichNine
        });
    }

    getTeeTimeBookingList() {
        let _clubCourseId;
        this.startCourses = []
        // let _courseId;
        // _courseId = this.courseId;
        let _currentDate;
        if (this.changeType === 'slotDate') _currentDate = this.currentDate;
        else _currentDate = this.forDate;


        _clubCourseId = this.isClub ? this.clubId : this.courseId
        this.flightService.getTeeTimeSlot(_currentDate, this.isClub, _clubCourseId)
            .subscribe((data: Array<TeeTimeSlotDisplay>) => {
                this.teeSlot = data;
                if (this.changeType === 'course') {
                    this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {
                        return tee.slot.teeOffTime === this.currentSlot.slotAssigned.teeOffTime && tee.slot.startCourse.id !== this.currentSlot.slotAssigned.startCourse.id
                    })
                } else {
                    this.teeSlot = this.teeSlot.filter((tee: TeeTimeSlotDisplay) => {

                        if (moment(tee.slot.teeOffDate, 'YYYY-MM-DD').format('YYYY-MM-DD') === this.forDate)
                            return tee.slot.teeOffTime !== this.currentSlot.slotAssigned.teeOffTime
                        else return true
                        // && (tee.slot.teeOffDate === moment().toDate() && (moment(tee.slot.teeOffTime,'HH:mm:ss').format('HH:mm') >= moment().format('HH:mm')))
                    })
                }


                this.teeSlot.forEach((t: TeeTimeSlotDisplay) => {
                    this.startCourses.push(t.slot.startCourse);
                })

                this.startCourses = this.getUnique(this.startCourses, 'id')
                this.startCourses.sort((a, b) => {
                    if (a.displayOrder < b.displayOrder) return -1
                    if (a.displayOrder > b.displayOrder) return 1
                    else 0
                })





            })
    }

    getUnique(arr, comp) {

        // store the comparison  values in array
        const unique = arr.map(e => e[comp])

            // store the indexes of the unique objects
            .map((e, i, final) => final.indexOf(e) === i && i)

            // eliminate the false indexes & return unique objects
            .filter((e) => arr[e]).map(e => arr[e]);

        return unique;
    }


    changeSlot(slot: TeeTimeSlotDisplay, type?: string) {

        if (!slot.available && type === 'slot' && this.changeType != 'slotDate') return false;
        // && type === 'course'
        this.flightService.getBookingFlightList(this.clubId, moment(slot.slot.teeOffDate).format('YYYY-MM-DD'), true)
            .subscribe((data) => {

                let _flightList: Array<TeeTimeBooking>
                let _hasFlight: Array<TeeTimeBooking>;
                if (data) {
                    _flightList = data.flightList;
                    _hasFlight = _flightList.filter((t: TeeTimeBooking) => {
                        return (t.slotAssigned.slotNo === slot.slot.slotNo) && (t.slotAssigned.slotDayId === slot.slot.slotDayId)
                    })


                }
                if (_hasFlight && _hasFlight.length > 0) {


                    if (_hasFlight[0].flight && _hasFlight[0].flight.status === 'PlayFinished') {

                        MessageDisplayUtil.showMessageToast('There is Finished Flight in this slot. Please choose different slot.',
                            this.platform, this.toastCtl, 3000, "bottom");
                        return false;
                    } else {
                        this.modalCtl.dismiss({
                            newSlot: slot,
                            currentSlot: this.currentSlot
                        });
                    }

                } else {
                    this.modalCtl.dismiss({
                        newSlot: slot,
                        currentSlot: this.currentSlot
                    });
                }

            })
        // if(1) return false;

    }
    // changeSlot(slot: TeeTimeSlotDisplay) {
    //
    //     if(!slot.available) return false;
    //     this.viewCtrl.dismiss({
    //         newSlot: slot,
    //         currentSlot: this.currentSlot
    //     });
    // }

    getSlotDetails(slot: TeeTimeSlotDisplay, attribute: string) {
        switch (attribute) {
            case 'time':
                let _time = moment(slot.slot.teeOffTime, 'HH:mm:ss').format('hh:mm A');
                return _time;
        }
    }

    getCurrentSlotDetails(attribute) {
        switch (attribute) {
            case 'time':
                let _time = moment(this.currentSlot.slotAssigned.teeOffTime, 'HH:mm:ss').format('hh:mm A');
                return _time;
            case 'courseName':
                let _courseName = this.currentSlot.slotAssigned.startCourse.name;
                return _courseName;
            case 'date':
                let _date = moment(this.currentSlot.slotAssigned.teeOffDate).format("ddd, DD MMM YYYY")
                return _date;
        }
    }

    getSlotClass(slot: TeeTimeSlotDisplay) {
        // if(slot.available) this.color = 'danger';
        // else this.color = 'primary'

        if (this.changeType === 'course') return 'slot-available'
        else {
            // return this.color
            if (slot.available) return 'slot-available';
            else return 'slot-not-available'
        }
    }



    changeDate(x: number) {
        this.currentDate = moment(this.currentDate).add(x, 'days').format("YYYY-MM-DD");
        // this.forDate = this.currentDate;
    }

    nextDate() {
        this.currentDate = moment(this.currentDate).add(1, 'days').format("YYYY-MM-DD");
        // this.forDate = this.currentDate;
    }

    prevDate() {
        this.currentDate = moment(this.currentDate).subtract(1, 'days').format("YYYY-MM-DD");
        // this.forDate = this.currentDate;
    }

    confirmDate() {
        //
        this.getTeeTimeBookingList();
    }


    onAddItem(x: number, item: any) {
        // if(this.itemReq === 0 && x < 0) return;
        // this.itemReq += x;
        if (item.itemCount === 0 && x < 0) return;
        this.additionalItems.filter((items) => {
            return items === item
        }).map((items) => {
            items.itemCount += x;
        })
    }

    onToggleRemarks(item: any) {
        this.additionalItems.filter((items) => {
            return items === item
        }).map((items) => {
            items.remarkShow = !items.remarkShow;
        })
    }

    getTotalAdditionalItems() {
        let _total = 0;
        _total = this.additionalItems.filter((items) => {
            return items.itemCount > 0
        }).map((items) => {
            return items.itemCount * items.unitPriceUsed
        }).reduce((a, b) => {
            return a + b
        }, 0);



        return _total;
    }

    getSlotPrices() {

    }

    getPricingComponents() {

    }

    getAdditionalItemDetails(item: any, attribute: string) {

        switch (attribute) {
            case 'name':
                return item && item.itemName;
            case 'playerType':
                let _playerType = '';
                if (this.mode === 'edit')
                    if (item && item.bookingPlayer && item.bookingPlayer.playerType)
                        _playerType = item.bookingPlayer.playerType.name
                    else _playerType = item.playerType;
                else _playerType = item.playerType;
                if (_playerType) return "(" + _playerType + ")"
                else return "";
            default:
                return;
        }
    }

    getBookingPlayerDetails(player: TeeTimeBookingPlayer, attribute: string) {
        if (!player) return;
        if (!attribute) return;

        switch (attribute) {
            case 'playerType':
                let _playerType = player ? player.playerTypeUsed ? player.playerTypeUsed : player.playerType.name : ''
                return '(' + _playerType + ')';
            case 'name':
                let _playerName = player ? player.playerName : ""
                return _playerName;
            default:
                return;
        }
    }

    refresh(){
        this.additionalItems = JSON.parse(JSON.stringify(this.initialItemValuesArray));
    }
}
